export default {
      id: "arrow-usage",
      viewBox: "0 0 15 12",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#arrow",
      toString: function () {
        return this.url;
      }
    }